import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";

function Navbar({ user, onLogout }) {
  const [coursesOpen, setCoursesOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  const courses = [
    { name: "Nursing", path: "/courses/nursing" },
    { name: "Paramedical", path: "/courses/paramedical" }
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setCoursesOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    // Close mobile menu on route change
    setMobileMenuOpen(false);
    setCoursesOpen(false);
  }, [location.pathname]);

  let loggedInMenu = [];
  if (user) {
    if (user.role === "admin") {
      loggedInMenu = [{ name: "Admin Panel", path: "/admin" }];
    } else if (user.role === "staff") {
      loggedInMenu = [{ name: "Staff Panel", path: "/staff" }];
    } else if (user.role === "student") {
      loggedInMenu = [{ name: "Student Panel", path: "/student" }];
    } else if (user.role === "principal") {
      loggedInMenu = [{ name: "Principal Panel", path: "/principal" }];
    }
  }

  return (
    <nav className="sgi-navbar">
      <div className="sgi-navbar-brand-left">
        <Link to="/" className="sgi-navbar-brand-link">Sarojini Group of Institutes</Link>
      </div>
      <button
        className={`sgi-navbar-mobile-toggle${mobileMenuOpen ? " open" : ""}`}
        aria-label="Toggle mobile menu"
        onClick={() => setMobileMenuOpen((open) => !open)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
      <ul className={`sgi-navbar-menu${mobileMenuOpen ? " mobile-open" : ""}`}>
        {!user ? (
          <>
            <li>
              <Link to="/" className={`sgi-navbar-link${location.pathname === "/" ? " active" : ""}`}>Home</Link>
            </li>
            <li>
              <Link to="/about" className={`sgi-navbar-link${location.pathname === "/about" ? " active" : ""}`}>About Us</Link>
            </li>
            <li className="sgi-navbar-dropdown" ref={dropdownRef}>
              <button
                type="button"
                className={`sgi-navbar-link sgi-navbar-link-dropdown${coursesOpen ? " active" : ""}`}
                onClick={() => setCoursesOpen((open) => !open)}
                aria-haspopup="true"
                aria-expanded={coursesOpen}
                tabIndex={0}
                style={{ cursor: "pointer" }}
              >
                Courses <span className="dropdown-arrow">▼</span>
              </button>
              {coursesOpen && (
                <ul className="sgi-navbar-dropdown-menu">
                  {courses.map((item, idx) => (
                    <li key={idx}>
                      <Link
                        to={item.path}
                        className="sgi-navbar-dropdown-item"
                        onClick={() => setCoursesOpen(false)}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li>
              <Link to="/contact" className={`sgi-navbar-link${location.pathname === "/contact" ? " active" : ""}`}>Contact</Link>
            </li>
            <li>
              <Link to="/login" className="sgi-navbar-login-link">Login</Link>
            </li>
          </>
        ) : (
          <>
            {loggedInMenu.map((item, idx) => (
              <li key={idx}>
                <Link to={item.path} className={`sgi-navbar-link${location.pathname === item.path ? " active" : ""}`}>
                  {item.name}
                </Link>
              </li>
            ))}
            <li>
              <button className="sgi-navbar-link sgi-navbar-logout-btn" onClick={onLogout}>
                Logout
              </button>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;